export default __webpack_public_path__ + "static/media/019-comet.ae619554.svg";